import { PerfilRole } from "./perfilRole.entity";

export class Perfil {
  public id: number;
  public nombre: string;
  public descripcion: string;
  public perfilRole: PerfilRole[];
  public roles?: string;

  //USO INTERNO
  public perfilRoleId: number[];
  public rolesCount?: number;
}
